import { render, staticRenderFns } from "./TableForm.vue?vue&type=template&id=c9669328"
import script from "./TableForm.vue?vue&type=script&lang=js"
export * from "./TableForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports